module.exports = __webpack_public_path__ + "img/pharma_fill.1c41a4bf.svg";